const programAccordionBlocks = document.querySelectorAll('.block-section.program-accordion');

if (programAccordionBlocks.length > 0) {
	programAccordionBlocks.forEach((block) => {
		const dayButtons = block.querySelectorAll('.program-accordion__day');
		const dayPanels = block.querySelectorAll('.program-accordion__day-panel');

		if (!dayButtons.length || !dayPanels.length) {
			return;
		}

		dayButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const selectedDay = button.dataset.day;

				dayButtons.forEach((dayButton) => {
					const isActive = dayButton.dataset.day === selectedDay;
					dayButton.classList.toggle('is-active', isActive);
					dayButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});

				dayPanels.forEach((panel) => {
					const isActive = panel.dataset.day === selectedDay;
					panel.classList.toggle('is-active', isActive);
					panel.hidden = !isActive;
				});
			});
		});
	});
}
